import locationIcon from '../../assets/icons/map/map-ubicacion-halo.svg';
import AcessIcon from '../../assets/stop/systemEntranceCercle.svg';
import AcessBlackIcon from '../../assets/stop/systemEntranceCercle_black.svg';
import {markerTypes} from '../../utils/utils';
import {initOverlay} from './map.overlay';
import fivem from '../../assets/icons/map/5m-light.svg';
import tenm from '../../assets/icons/map/10m-light.svg';

const MARKER_WIDTH = 18;
const MARKER_HEIGHT = 24;
const MARKER_SQUARE_SIZE = 24;
let lastMarker: any;

/* eslint-disable */
export enum IconTypes {
  NO_STOP,
  HOME,
  LOCATION,
  BUS,
  FGC,
}
let overlayInstance: any =  [];
let overlayMarkerInstance: any =  [];
/* eslint-enable */
export const addClickMapEvent = (map: any, history: any, markerList: any) =>{
    let timeout: any;
    const initIntervalLongPres = (e: any) =>{
        clearInterval(timeout);
    };
    const clickEvent = (e: any) => {
        // console.log('click');
        timeout = setTimeout(function() {
            clearInterval(timeout);
            cleanNonStopMarker(markerList);
            const newMarker = createMaker(map, e.latLng, markerTypes.NO_STOP, e);
            markerList[markerTypes.NO_STOP] = [newMarker];
            history.push(`/serveis-aprop?lat=${e.latLng.lat()}&lng=${e.latLng.lng()}`);
        }, 500);
    };
    map.addListener('mousedown', clickEvent.bind(history));
    map.addListener('mouseup', initIntervalLongPres.bind(timeout));
};
export const cleanNonStopMarker = (markerList: any) => {
    if (markerList[markerTypes.NO_STOP]) {
        markerList[markerTypes.NO_STOP][0].setMap(null);
    }
};
// Create a custom marker
export const createMaker = (
    map: any,
    coord: any,
    type: string,
    markerInfo: any,
    transportIcons?: any,
) => {
    if (markerTypes.LOCATION !=type && markerTypes.NO_STOP !=type) {
        const size: any = getIconSize(type);
        const marker = new google.maps.Marker({
            position: coord,
            map: map,
            icon: {
                url: transportIcons[type],
                scaledSize: new google.maps.Size(size.width, size.height),
            },
            optimized: true,
        });
        marker.set('stop_data', markerInfo);
        return marker;
    } else {
        const size: any = getIconSize(type);
        const marker = new google.maps.Marker({
            position: coord,
            map: map,
            icon: {
                url: locationIcon,
                scaledSize: new google.maps.Size(size.width, size.height),
            },
            optimized: true,
        });
        marker.set('stop_data', markerInfo);
        // console.log(map);
        map.map.setCenter(coord);
        if (markerTypes.LOCATION == type) {
            const zoom: number = map.getZoom();
            if (zoom > 14) {
                const overlay5m = initOverlay(map, '5', coord, fivem);
                overlayInstance.push(overlay5m?.polylineDotted);
                overlayMarkerInstance.push(overlay5m?.distanceMarker);
                const overlay10m = initOverlay(map, '10', coord, tenm);
                overlayInstance.push(overlay10m?.polylineDotted);
                overlayMarkerInstance.push(overlay10m?.distanceMarker);
                const overlay30m = initOverlay(map, '30', coord, tenm);
                overlayInstance.push(overlay30m?.polylineDotted);
                overlayMarkerInstance.push(overlay30m?.distanceMarker);
            }
            if (13 < zoom && zoom <= 14) {
                const overlay10m = initOverlay(map, '10', coord, fivem);
                overlayInstance.push(overlay10m?.polylineDotted);
                overlayMarkerInstance.push(overlay10m?.distanceMarker);
                const overlay30m = initOverlay(map, '30', coord, tenm);
                overlayInstance.push(overlay30m?.polylineDotted);
                overlayMarkerInstance.push(overlay30m?.distanceMarker);
            }
            if (11 < zoom && zoom <= 13) {
                const overlay30m = initOverlay(map, '30', coord, tenm);
                overlayInstance.push(overlay30m?.polylineDotted);
                overlayMarkerInstance.push(overlay30m?.distanceMarker);
            }
        }
        return marker;
    }
};

export const clearOverlay = () =>{
    if (overlayInstance.length> 0 ) {
        overlayInstance.forEach((overlay: any)=>{
            overlay.setMap(null);
        });
    }
    if (overlayMarkerInstance.length> 0 ) {
        overlayMarkerInstance.forEach((overlayMarker: any)=>{
            overlayMarker.setMap(null);
        });
    }
};

export const resetOver = (map: any) =>{
    if (overlayInstance.length> 0 ) {
        overlayInstance.forEach((overlay: any)=>{
            overlay.setMap(map);
        });
    }
    if (overlayMarkerInstance.length> 0 ) {
        overlayMarkerInstance.forEach((overlayMarker: any)=>{
            overlayMarker.setMap(map);
        });
    }
};

export const createAccesMaker = (
    map: any,
    coord: any,
    type: string,
    markerInfo: any,
) => {
    const size: any = getAcessSize();
    const marker = new google.maps.Marker({
        position: coord,
        map: map,
        icon: {
            url: AcessIcon,
            scaledSize: new google.maps.Size(size.width, size.height),
        },
        optimized: true,
    });

    marker.set('stop_data', markerInfo);
    return marker;
};

export const deleteMarkerLocation = (markerList: any) =>{
    if (markerList['location']?.length) {
        markerList['location'][0].setMap(null);
    }
};

const getAcessSize =() => {
    const size: any = {};
    size.width = MARKER_WIDTH;
    size.height = MARKER_HEIGHT;
    return size;
};

const getIconSize = (type: string) => {
    const size: any = {};
    if (type === markerTypes.FGC) {
        size.width = MARKER_SQUARE_SIZE;
        size.height = MARKER_SQUARE_SIZE;
    } else {
        size.width = MARKER_WIDTH;
        size.height = MARKER_HEIGHT;
    }
    return size;
};
export const changeMarkerAccesColor = (markerId: any, accessList: any) =>{
    accessList.forEach((marker: any)=>{
        const size = getAcessSize();
        if (marker.stop_data.id == markerId) {
            marker.setIcon({
                url: AcessBlackIcon,
                scaledSize: new google.maps.Size(size.width, size.height),
            });
        } else {
            marker.setIcon({
                url: AcessIcon,
                scaledSize: new google.maps.Size(size.width, size.height),
            });
        }
    });
};
export const changeMarkerSize = (
    marker: any,
    type: string,
    transportIcons?: any,
)=>{
    const size = getIconSize(type);
    marker.setIcon({
        url: transportIcons[type],
        scaledSize: new google.maps.Size(26, 33),
    });
    if (lastMarker) {
        lastMarker.setIcon({
            url: transportIcons[lastMarker.stop_data.slug],
            scaledSize: new google.maps.Size(size.width, size.height),
        });
    }

    lastMarker = marker;
};

changeMarkerSize.bind(lastMarker);

export const getTopNearMarkersByType = (markerList:{[index:string]: any}, latLng: google.maps.LatLng, type: string) => {
    const distancePerMarker: Array<any> = [];
    markerList[type]?.map((marker: google.maps.Marker) => {
        const distance = google.maps.geometry.spherical.computeDistanceBetween(
      marker.getPosition() as google.maps.LatLng,
      latLng,
        );
        if (distance<500) {
            distancePerMarker.push([distance, marker]);
        }
    });
    distancePerMarker?.sort((a:any, b:any) => a[0] - b[0]);
    // console.log('MarkerList', distancePerMarker);
    return distancePerMarker?.map((item: any) => item[1].get('stop_data'));
};

// delete All the marker in map
export const removeMarkers = (markerList: any)=>{
    const types = Object.keys(markerList);
    types?.forEach((type: string)=>{
        markerList[type].forEach((marker: any)=>{
            marker.setMap(null);
        });
    });
};

export const hideOrShowMarker = (
    state: boolean = true,
    type: string= '',
    markerList: any,
    map: any,
    activeFilters: any= [],
) => {
    if (!!markerList[type]) {
        const _map = (state) ? map: null;
        markerList[type].forEach((marker: any)=>{
            marker.setMap(_map);
            marker.layerActive= state;
        });
    }
};

export const hideOrShowMarkerLineDetail = (
    state: boolean = true,
    type: string= '',
    markerList: any,
    map: any,
    stops: any= [],
) => {
    if (!!markerList[type]) {
        const _map = (state) ? map: null;
        markerList[type].forEach((marker: any)=>{
            if (stops.indexOf(marker.stop_data.stop_id)>=0) {
                marker.setMap(_map);
                marker.layerActive= state;
            } else {
                marker.setMap(null);
            }
        });
    }
};

export const hideOrShowMarkerStopDetail = (
    state: boolean = true,
    type: string= '',
    markerList: any,
    map: any,
    stop: any,
) => {
    if (!!markerList[type]) {
        const _map = (state) ? map: null;
        const keys = Object.keys(markerList);
        keys.forEach((key:string) => {
            markerList[type].forEach((marker: any)=>{
                if (stop.stop_id === marker.stop_data.stop_id) {
                    marker.setMap(_map);
                } else {
                    marker.setMap(null);
                }
            });
        });
    }
};

export const resetMarkers = (markerList: any =[], map: any) =>{
    const hideOrShow = (marker: any, map: any)=>{
        if (marker.layerActive === undefined|| marker.layerActive) {
            marker.layerActive = true;
        } else {
            marker.layerActive = false;
        }
        if (marker.layerActive) {
            marker.setMap(map);
        }
    };

    const types = Object.keys(markerList);
    if (types.length>0) {
        types.forEach((type:string)=>{
            markerList[type]?.forEach((marker: any)=>{
                hideOrShow(marker, map);
            });
        });
    }
};

export const hideOrShowOnMarkersOnViewport = (markerList: any, map: any)=>{
    const hideOrShow = (marker: any, map: any)=>{
        if (map?.getBounds().contains(marker.position)) {
            if (marker.layerActive === undefined || marker.layerActive) {
                marker.layerActive = true;
            } else {
                marker.layerActive = false;
            }
            if (marker.layerActive) {
                marker.setMap(map);
            }
        } else {
            marker.setMap(null);
        }
    };
    const types = Object.keys(markerList);
    if (types.length>0) {
        types.forEach((type:string)=>{
            markerList[type]?.forEach((marker: any)=>{
                hideOrShow(marker, map);
            });
        });
    }
};
